// extracted by mini-css-extract-plugin
export default {"container":"Scheduler_container__LNVbR","dropdown":"Scheduler_dropdown__P9COP","resourceLabel":"Scheduler_resourceLabel__yr4lc"};